import IncludeFragmentElement from '@github/include-fragment-element';

/**
 * We are using https://github.com/github/include-fragment-element.
 *
 * Please refer to above link for documentation.
 *
 * We have extended the following:
 *
 * Request
 *
 * So that it matches with preload fetch because they need to be the same to work
 *
 * Events:
 * - fragmentInclude:loadstart
 * - fragmentInclude:load
 * - fragmentInclude:loadend
 * - fragmentInclude:replace
 * - fragmentInclude:replaced
 *
 * @prop src - Url to html
 * @prop timeout - Timeout time
 * @prop loading - lazy (eager is default)
 * @prop accept - HTTP accept headers (don't use on our project)
 */
export default class FragmentInclude extends IncludeFragmentElement {
  connectedCallback() {
    super.connectedCallback();
    this.currentParent = this.parentElement;
  }

  dispatchEvent(event) {
    const type = event.type.replace('include-fragment-', '');
    const name = `fragmentInclude:${type}`;
    const newEvent = new Event(name, {
      bubbles: true,
      cancelable: event.cancelable,
    });
    newEvent.realTarget = this;
    newEvent.details = event.details;
    return this.currentParent.dispatchEvent(newEvent);
  }

  request() {
    const { src } = this;
    if (!src) {
      throw new Error('missing src');
    }
    const headers = new Headers();

    // Please note is you use accept headers, preload link will not work
    if (this.accept) {
      headers.append('Accept', this.accept);
      headers.append('Origin', window.location.origin);
    }
    return new Request(src, {
      headers,
      method: 'GET',
      credentials: 'same-origin',
    });
  }
}

customElements.get('ef-fragment-include') ||
  customElements.define('ef-fragment-include', FragmentInclude);
